var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.417.883c-2.75-.8-4.65-.733-5.967.25-1.583 1.183-1.766 3.317-1.766 4.833v4.15c0 4.1 1.866 6.184 5.533 6.184H28c1.5 0 3.65-.184 4.834-1.767 1.016-1.3 1.1-3.2.283-5.95-1.067-3.617-4.083-6.633-7.7-7.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M26.798 18.483h-5.966a5.32 5.32 0 0 1-5.317-5.317V7.199a2.28 2.28 0 0 0-.783-1.716 2.259 2.259 0 0 0-1.784-.55c-3.916.5-7.516 2.65-9.866 5.883C.715 14.066-.152 18.033.598 21.999c1.084 5.734 5.667 10.317 11.417 11.4.917.184 1.833.267 2.75.267 3.017 0 5.933-.933 8.417-2.75 3.233-2.35 5.383-5.95 5.883-9.867a2.24 2.24 0 0 0-.55-1.783 2.28 2.28 0 0 0-1.717-.783Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorIcon);
export default __webpack_public_path__ + "static/media/sectorIcon.4956f8ecc4380023aa865c61a87b3805.svg";
export { ForwardRef as ReactComponent };